import React, { memo } from 'react';
import { useTheme, useMediaQuery } from "@mui/material";
import DataTable from "./DataTable";
import DataCard from "./DataCard";

const DataContainer = (props) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	if (isMobile) {
		return <DataCard {...props} />;
	}

	return <DataTable {...props} />;
};

export default memo(DataContainer);
